import { motion } from "framer-motion";

export const PageHero = ({ overline, title, subtitle }: { overline: string; title: string; subtitle?: string }) => (
  <section className="relative bg-[#090A0C] pt-36 pb-20 md:pt-44 md:pb-24 overflow-hidden">
    <div className="absolute inset-0 blueprint-grid opacity-60" style={{ ["--grid-line" as string]: "rgba(59,130,246,0.08)" }} />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-[#3B82F6] mb-5"
      >
        {overline}
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="font-heading font-medium text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-white max-w-3xl"
      >
        {title}
      </motion.h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-6 text-base md:text-lg text-white/60 max-w-2xl leading-relaxed"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
